import React, { useEffect, useState, useRef } from 'react';
import superadminapi, { getApiDefaultSendBox, updateApisStatusByUserName, updateCategoryStatusByUsername, getApisStatusByUsername, getCategoryStatusByUsername } from '../../../Base/SuperAdminConfig';
import Message from '../../../Components/Message/Message';
import Loading from '../../../Components/Loading/Loading';
import styles from "../client-details.module.css";

export default function APIStatus(props) {
    const userName = props?.details?.userName;
    const [ sandboxApiList, setSandboxApiList ] = useState([]);
    const [ categoryAndServices, setCategoryAndServices ] = useState([]);
    const [ message, setMessage ] = useState('');
    const [ messageClass, setMessageClass ] = useState('');
    const [ openIndex, setOpenIndex ] = useState(null); // For accordion
    const [ apiList, setApiList ] = useState({});
    const [ updateLoader, setUpdateLoader ] = useState(true);
    const [ categoryStatus, setCategoryStatus ] = useState('');

    useEffect(() => {
        if(userName){
            fetchDefaultFunction();
            fetchCategoryStatusFunction();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userName])

    const fetchDefaultFunction = () => {
        superadminapi.get(getApiDefaultSendBox)
        .then((res) => {
            if(res.data.code === 200){
                setSandboxApiList(res.data.apiData);
                fetchApiStatusFunction(res.data.apiData);
                setCategoryAndServices(getCategoriesWithServices(res.data.apiData));
            } else {
                setUpdateLoader(false);
                setSandboxApiList([]);
            }
        })
        .catch((error) => {
            setUpdateLoader(false);
            console.error(error);
        })
    }

    const fetchApiStatusFunction = (apiData) => {
        superadminapi.get(getApisStatusByUsername + userName)
        .then((res) => {
            setUpdateLoader(false);
            if(res.data.code === 200){
                setApiList(res.data.apis);
            } else {
                setApiList(getAllKeysFunction(apiData));
            }
        })
        .catch((error) => {
            setUpdateLoader(false);
            console.error(error);
        })
    }

    const getAllKeysFunction = (list) => {
        return list.reduce((acc, item) => {
            if (item.services) {
                acc[item.services] = true;
            }
            return acc;
        }, {});
    }

    function getCategoriesWithServices(apiData) {
        const categoryMap = apiData.reduce((acc, item) => {
            if (item.category && item.services) {
                if (!acc[item.category]) {
                    acc[item.category] = [];
                }
                acc[item.category].push({
                    name: item.name,
                    services: item.services
                });
            }
            return acc;
        }, {});
        return Object.entries(categoryMap).map(([category, services]) => ({
            category,
            services
        }));
    }

    const handleAccordionClick = (idx) => {
        setOpenIndex(openIndex === idx ? null : idx);
    };

    // Animation helper
    const contentRefs = useRef([]);

    const updateApiStatusFunction = (key, value) => {
        setUpdateLoader(true);
        superadminapi.post(updateApisStatusByUserName, {
            userName,
            key,
            value
        })
        .then((res) => {
            setUpdateLoader(false);
            if(res.data.code === 200){
                fetchApiStatusFunction();
                fetchCategoryStatusFunction();
                setMessageClass('success');
                setMessage(res.data.message);
                setTimeout(() => {
                    setMessage('')
                }, 2000);
            } else {
                setMessageClass('error');
                setMessage(res.data.message);
                setTimeout(() => {
                    setMessage('')
                }, 2000);
            }
        })
        .catch((error) => {
            setUpdateLoader(false);
            console.error(error);
        })
    }

    const updateCategoryStatusFunction = (category, value) => {
        setUpdateLoader(true);
        superadminapi.post(updateCategoryStatusByUsername, {
            userName,
            category,
            value
        })
        .then((res) => {
            setUpdateLoader(false);
            if(res.data.code === 200){
                fetchApiStatusFunction();
                fetchCategoryStatusFunction();
                setMessageClass('success');
                setMessage(res.data.message);
                setTimeout(() => {
                    setMessage('')
                }, 2000);
            } else {
                setMessageClass('error');
                setMessage(res.data.message);
                setTimeout(() => {
                    setMessage('')
                }, 2000);
            }
        })
        .catch((error) => {
            setUpdateLoader(false);
            console.error(error);
        })
    }

    const fetchCategoryStatusFunction = () => {
        superadminapi.get(getCategoryStatusByUsername + userName)
        .then((res) => {
            setUpdateLoader(false);
            if(res.data.code === 200){
                setCategoryStatus(res.data.categoriesStatus);
            } else {
                setCategoryStatus('');
            }
        })
        .catch((error) => {
            setUpdateLoader(false);
            console.error(error);
        })
    }

    return (<>
        {message && <Message message={message} messageClass={messageClass} closeMessage={() => setMessage('')} />}
        {updateLoader && <div className={styles['update-loader']}><Loading /></div>}
        <h5 className={styles['documentation-heading']}>API status</h5>
        <div className={styles['accordion-container']}>
            <div className={styles['accordion-label']}>
                <i>&nbsp;</i>
                <div>Category name</div>
                <div>Action</div>
            </div>
            {categoryAndServices.map((cat, idx) => (
                <div className={styles['accordion-item']} key={cat.category}>
                    <div className={styles['accordion-heading']} onClick={() => handleAccordionClick(idx)}>
                        <i className={`fa fa-angle-right ${styles[openIndex === idx && 'active']}`}></i>
                        {cat.category}
                        <div>
                            <span className={styles[!(categoryStatus[cat.category]===false) ? 'visible' : '']} onClick={e => {e.stopPropagation(); updateCategoryStatusFunction(cat.category, true);}}><i className={`fa fa-${!(categoryStatus[cat.category]===false) ? 'check-' : ''}circle-o`}></i> Show</span>
                            <span className={styles[!(categoryStatus[cat.category]===false) ? '' : 'hidden']} onClick={e => {e.stopPropagation(); updateCategoryStatusFunction(cat.category, false);}}><i className={`fa fa-${(categoryStatus[cat.category]===false) ? 'check-' : ''}circle-o`}></i> Hide</span>
                        </div>
                    </div>
                    <div
                        ref={el => contentRefs.current[idx] = el}
                        style={{
                            maxHeight: openIndex === idx ? contentRefs.current[idx]?.scrollHeight + 25 + 'px' : '0px'
                        }}
                        className={styles['accordion-content']}
                    >
                        <ul>
                            <div className={styles['api-label']}>
                                <div>API name</div>
                                <div>Action</div>
                            </div>
                            {sandboxApiList.filter(item => item.category === cat.category).map((item, i) => (
                                <li className={styles['api-name']} key={i}>
                                    <p>➔ {item.name}</p>
                                    <div>
                                        <span className={styles[!(apiList[item.services]===false) ? 'visible' : '']} onClick={() => updateApiStatusFunction(item.services, true)}><i className={`fa fa-${!(apiList[item.services]===false) ? 'check-' : ''}circle-o`}></i> Show</span>
                                        <span className={styles[!(apiList[item.services]===false) ? '' : 'hidden']} onClick={() => updateApiStatusFunction(item.services, false)}><i className={`fa fa-${(apiList[item.services]===false) ? 'check-' : ''}circle-o`}></i> Hide</span>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            ))}
        </div>
    </>);
}